// Will read from the state of the GenreCommunitiesStore.
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Spin } from 'antd';
import StepControlButtons from '../UI/StepControlButtons.js';
import { connectToGenreStore } from '../Stores/GenreStore';
import { Translate } from 'react-localize-redux';

class GenreStep extends React.Component {
	static propTypes = {
		genreStore: PropTypes.shape({
			state: PropTypes.object,
			toggleCheck: PropTypes.func,
		}),
		nextStep: PropTypes.func,
		previousStep: PropTypes.func,
	};

	render() {
		const { genreStore: store } = this.props;
		const { state } = store;

		return (
			<div className="wizard-content">
				<h1>
					<Translate id="genre_communities" />
				</h1>
				<p>
					<Translate id="genre_communities_description" />
				</p>
				<div className="wizard-checkboxes">
					{this.renderCheckboxes(state)}
				</div>
				<p className="italic">
					<Translate id="genre_communities_disclaimer" />
				</p>
				<StepControlButtons
					goNext={state.loading ? null : this.props.nextStep}
					goBack={this.props.previousStep}
				/>
			</div>
		);
	}

	renderCheckboxes = state => {
		if (state.loading) {
			return (
				<Spin wrapperClassName="full-height">
					<div />
				</Spin>
			);
		}

		const communities = state.communities;
		const keys = Object.keys(communities);
		const checkboxes = [];

		for (let i = 0; i < keys.length; i += 2) {
			const item = communities[keys[i]];
			const next = communities[keys[i + 1]];

			checkboxes.push(
				<div key={item.id} className="wizard-checkbox-row">
					<div className="wizard-checkbox-col">
						{item && this.renderCheckbox(item)}
					</div>
					<div className="wizard-checkbox-col">
						{next && this.renderCheckbox(next)}
					</div>
				</div>,
			);
		}

		return checkboxes;
	};

	renderCheckbox = community => {
		const { genreStore: store } = this.props;

		return (
			<div className="wizard-checkbox">
				<Checkbox
					key={community.id}
					checked={community.isChecked}
					onChange={() => store.toggleCheck(community.id)}>
					{community.name}
				</Checkbox>
			</div>
		);
	};
}

export default connectToGenreStore(GenreStep);
